import UITag from 'UIComponents/tag/UITag';
import { jsx as _jsx } from "react/jsx-runtime";
export const tagTypes = {
  DEFAULT: 'default',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning'
};
function Tag(props) {
  const {
    children,
    type = tagTypes.DEFAULT
  } = props;
  return /*#__PURE__*/_jsx(UITag, {
    inline: true,
    use: type,
    children: children
  });
}
export default Tag;